module.exports = __webpack_public_path__ + "img/successPayment.680630ba.svg";